import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import {CategoryProvider} from "../../contexts/categoryContext/CategoryContext";
import {SubCategoryProvider} from "../../contexts/categoryContext/SubCategoryContext";
import {MartProvider} from "../../contexts/mart/MartContext";

const MartFragment = Loadable(lazy(() => import('./views/MartFragment')));
const AddMartFragment = Loadable(lazy(() => import('./views/AddMartFragment')));

const martRoutes = [
  { path: '/add_mart', element: <MartProvider><AddMartFragment /></MartProvider> },
  { path: '/update_mart/:id', element: <MartProvider><AddMartFragment /></MartProvider> },
  { path: '/marts', element: <MartProvider><MartFragment /></MartProvider> },
];

export default martRoutes;
